"use strict";
/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlusIcon = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var forwardRef_1 = require("../../helpers/forwardRef");
var Icon_1 = require("../../internal/Icon");
var PlusIcon16Light_1 = require("./PlusIcon16Light");
var PlusIcon16Regular_1 = require("./PlusIcon16Regular");
var PlusIcon16Solid_1 = require("./PlusIcon16Solid");
var PlusIcon20Light_1 = require("./PlusIcon20Light");
var PlusIcon20Regular_1 = require("./PlusIcon20Regular");
var PlusIcon20Solid_1 = require("./PlusIcon20Solid");
var PlusIcon24Regular_1 = require("./PlusIcon24Regular");
var PlusIcon24Solid_1 = require("./PlusIcon24Solid");
var PlusIcon32Regular_1 = require("./PlusIcon32Regular");
var PlusIcon64Regular_1 = require("./PlusIcon64Regular");
var sizes = {
    16: {
        light: PlusIcon16Light_1.PlusIcon16Light,
        regular: PlusIcon16Regular_1.PlusIcon16Regular,
        solid: PlusIcon16Solid_1.PlusIcon16Solid,
    },
    20: {
        light: PlusIcon20Light_1.PlusIcon20Light,
        regular: PlusIcon20Regular_1.PlusIcon20Regular,
        solid: PlusIcon20Solid_1.PlusIcon20Solid,
    },
    24: {
        regular: PlusIcon24Regular_1.PlusIcon24Regular,
        solid: PlusIcon24Solid_1.PlusIcon24Solid,
    },
    32: {
        regular: PlusIcon32Regular_1.PlusIcon32Regular,
    },
    64: {
        regular: PlusIcon64Regular_1.PlusIcon64Regular,
    },
};
exports.PlusIcon = forwardRef_1.forwardRef('PlusIcon', function (props, ref) {
    return react_1.default.createElement(Icon_1.Icon, tslib_1.__assign({ ref: ref }, props, { sizes: sizes }));
});
